import { functions } from '@/firebase';
import { httpsCallable } from 'firebase/functions';
import {
  BusOrder,
  GetPaymentUrlRequest,
  GetPaymentUrlResponse,
  Order,
  PlaceBusOrderRequest,
  PlaceOrderRequest,
  PlaceTicketOrderRequest,
} from '@packages/types';
import { TransferTicketRequest } from '@packages/types/requestTypes';

export const placeOrderFn = httpsCallable<PlaceOrderRequest, { order: Order }>(
  functions,
  'placeOrder',
);
export const placeTicketOrderFn = httpsCallable<PlaceTicketOrderRequest, { order: Order }>(
  functions,
  'placeTicketOrder',
);
export const getPaymentUrl = httpsCallable<GetPaymentUrlRequest, GetPaymentUrlResponse>(
  functions,
  'getPaymentUrl',
);
export const placeBusOrderFn = httpsCallable<PlaceBusOrderRequest, { busOrder: BusOrder }>(
  functions,
  'placeBusOrder',
);

export const transferTicketFn = httpsCallable<TransferTicketRequest, null>(
  functions,
  'transferTicket',
);
